import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#424242"
      d="M7.5 13.5a.5.5 0 0 0 1 0V3.803l3.628 4.031a.5.5 0 1 0 .744-.668l-4.5-5a.5.5 0 0 0-.744 0l-4.5 5a.5.5 0 0 0 .744.668L7.5 3.803z"
    />
  </svg>
);
export default SvgArrowUp;
